import { fetch } from 'http-common';

import { DeliveryCodeDto } from 'types/api/orders.type';

export type DeliveryCodesQuery = {
  season?: string;
  linesheet?: string;
  isActive?: boolean;
  startShipDate?: string;
  endShipDate?: string;
};

class DeliveryCodesDataService {
  private http = fetch();

  private ep = '/v1/delivery-codes';

  public getDeliveryCodes(params: DeliveryCodesQuery) {
    return this.http.get<DeliveryCodeDto[]>(this.ep, { params });
  }
}

const deliveryCodesDataService = new DeliveryCodesDataService();

export { deliveryCodesDataService };
